export * from './replaceBaseOrigin';
export * from './setOriginUrl';

export { default as getAccountBaseUrl } from './getAccountBaseUrl';
export { default as getConsoleBaseUrl } from './getConsoleBaseUrl';
